
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"56","height":"58","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M48.4 47.5a3.25 3.25 0 01-3.25 3.25H6.25A3.25 3.25 0 013 47.5V5.25A3.25 3.25 0 016.25 2h32.5a3.25 3.25 0 012.269.923l6.402 6.246a3.25 3.25 0 01.98 2.327V47.5z","fill":"#fff","stroke":"#1C9AF2","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M21 33s1.333-2.5 5-2.5 5 2.5 5 2.5","stroke":"#1C9AF2","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"20","cy":"24","r":"2","fill":"#1C9AF2"}}),_c('circle',{attrs:{"cx":"32","cy":"24","r":"2","fill":"#1C9AF2"}}),_c('path',{attrs:{"d":"M44 17.395C44 18.834 42.88 20 41.5 20S39 18.834 39 17.395C39 15.957 41.5 12 41.5 12s2.5 3.957 2.5 5.395zm-5-6.349c0 1.08-.895 1.954-2 1.954s-2-.875-2-1.954C35 9.969 37 7 37 7s2 2.968 2 4.046z","fill":"#1C9AF2"}}),_c('circle',{attrs:{"cx":"48","cy":"50","r":"8","fill":"#1C9AF2"}}),_c('path',{attrs:{"fill":"#1C9AF2","d":"M45 47h6v6h-6z"}}),_c('path',{attrs:{"d":"M45 53l6-6m0 6l-6-6","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    